import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { Box, Grid, Link, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { di } from '../../../state/inversify.config';
import { CreateIncidentDomainService } from '../createIncidentDomainService';
import { getRouteByAccountType } from '../../../routes/getRouteByAccountType';
import { IncidentSuccessFullyCreatedMessage } from '../dumb/incidentSuccessfullyCreatedMessage.dumb';
import { AuthService } from '../../../state/helperServices/auth/auth.service';
import { Button } from '../../../components/button/button';

export function IncidentCreatedSuccessfully() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const incidentDomainService = di.get<CreateIncidentDomainService>(
    CreateIncidentDomainService,
  );

  // TODO: move into a domainService and only return accountType or even better find a way so that you don't have to send down the accountType
  const authService = di.get<AuthService>(AuthService);
  const loggedInUser = authService.useLoggedInUserSelector();

  const guardians = incidentDomainService.usePlayersGuardianSelector();
  const player = incidentDomainService.useSelectedPlayerSelector();
  const { firstName: playerFirstName } = player;

  const onRedirectToHome = () => {
    incidentDomainService.dispatchResetStep();
    navigate(`/${getRouteByAccountType(loggedInUser.accountType)}`);
  };

  const handleOnCreateSymptom = (playerId: string) => {
    navigate(
      `/${getRouteByAccountType(
        loggedInUser.accountType,
      )}/create-symptom-check`,
      { state: { selectedPlayerId: playerId } },
    );
  };

  useEffect(() => {
    incidentDomainService.dispatchClearIncidentCreationView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Grid
      container
      spacing={6}
      direction="column"
      justifyContent="space-between"
      alignItems="center"
      p={6}
    >
      <Grid item sx={{ my: 1 }}>
        {guardians && (
          <IncidentSuccessFullyCreatedMessage
            user={loggedInUser}
            guardians={guardians}
          />
        )}
      </Grid>

      <Grid item sx={{ my: 1 }}>
        <CheckCircleIcon color="primary" fontSize="large" />
      </Grid>

      <Grid item sx={{ my: 1 }}>
        <Typography variant="body1" textAlign="center">
          <Trans
            i18nKey="symptom.SYMPTOM_CHECK_PROMPT"
            values={{ playerFirstName }}
          />
        </Typography>
        <Button
          sx={{ mt: 2 }}
          type="submit"
          fullWidth
          color="secondary"
          variant="contained"
          onClick={() => handleOnCreateSymptom(player.id)}
          label={t('symptom.CHECK_PLAYERS_SYMPTOMS', {
            playerFirstName,
          })}
        />

        <Button
          sx={{ textTransform: 'none', textDecoration: 'underline', mt: 2 }}
          type="submit"
          fullWidth
          variant="text"
          onClick={() => onRedirectToHome()}
          label={t('MAYBE_LATER')}
        />
      </Grid>
    </Grid>
  );
}
